"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _StepperValueHeader = _interopRequireDefault(require("./StepperValueHeader"));
var _StepperValue = _interopRequireDefault(require("./StepperValue.style"));
var _StepperMember = _interopRequireDefault(require("./StepperMember"));
var _button = require("../../button");
var _helpers = require("./helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var FormulaValue = function FormulaValue(props) {
  var errors = props.errors,
    rule = props.rule,
    labels = props.labels,
    ruleIndex = props.ruleIndex,
    ruleChange = props.ruleChange,
    actions = props.actions,
    setHasChanges = props.setHasChanges,
    formulaOtherProps = props.formulaOtherProps;
  var stepperErrors = errors.stepper;
  var steps = rule.stepper.activeType === _helpers.ACTIVE_TYPES.fixed ? rule.stepper[_helpers.ACTIVE_TYPES.fixed].steps : rule.stepper[_helpers.ACTIVE_TYPES.percentage].steps;
  var ruleUpdate = function ruleUpdate(index) {
    return function (value) {
      var newValue = _toConsumableArray(R.path(['stepper', rule.stepper.activeType, 'steps'], rule));
      newValue[index] = _objectSpread(_objectSpread({}, steps[index]), value);
      ruleChange('stepper', _objectSpread(_objectSpread({}, rule.stepper), {}, _defineProperty({}, rule.stepper.activeType, {
        steps: newValue
      })));
    };
  };
  var addRule = function addRule() {
    ruleUpdate(steps.length)((0, _helpers.emptyRule)());
  };
  var removeStep = function removeStep(index) {
    var currentValue = _toConsumableArray(R.path(['stepper', rule.stepper.activeType, 'steps'], rule));
    ruleChange('stepper', _objectSpread(_objectSpread({}, rule.stepper), {}, _defineProperty({}, rule.stepper.activeType, {
      steps: R.remove(index, 1, currentValue)
    })));
  };
  return /*#__PURE__*/_react["default"].createElement(_StepperValue["default"], {
    "data-testid": "stepper-value-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_StepperValueHeader["default"], {
    rule: rule,
    ruleIndex: ruleIndex,
    ruleChange: ruleChange,
    labels: labels,
    actions: actions,
    setHasChanges: setHasChanges
  }), steps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement(_StepperMember["default"], _extends({}, formulaOtherProps, {
      key: step.key,
      data: step,
      error: stepperErrors && stepperErrors[rule.stepper.activeType][index],
      index: index,
      labels: labels,
      ruleChange: ruleUpdate(index),
      removeStep: removeStep,
      setHasChanges: setHasChanges
    }));
  }), /*#__PURE__*/_react["default"].createElement(_button.Button, {
    type: "naked",
    icon: "ion-android-add",
    className: "stepper-button-add",
    action: addRule
  }, labels.STEP_ADD));
};
FormulaValue.defaultProps = {
  errors: {},
  formulaOtherProps: {}
};
FormulaValue.propTypes = {
  ruleIndex: _propTypes["default"].number.isRequired,
  rule: _propTypes["default"].shape({
    stepper: _propTypes["default"].shape({
      activeType: _propTypes["default"].string
    })
  }).isRequired,
  errors: _propTypes["default"].shape({
    stepper: _propTypes["default"].shape({})
  }),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  actions: _propTypes["default"].shape({
    deleteRuleBlock: _propTypes["default"].func
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = FormulaValue;